import type { KaiFilterContext } from "@/components/table";
import { buildBookingsFilterContextSnapshot } from "@/features/bookings/bookingTableFilters";

/**
 * Build the PropertyFilter snapshot Kai receives in `client_context.filter_context`
 * when the user is on the Bookings page, or `undefined` on any other route.
 */
export function buildKaiFilterContext(
  pathname: string,
): KaiFilterContext | undefined {
  if (pathname === "/bookings" || pathname.startsWith("/bookings/")) {
    return buildBookingsFilterContextSnapshot();
  }
  return undefined;
}
